import { whiteboardClient as api } from "../axiosClient";

const whiteboardShareResource = {
    index: async ({ page, perPage, boardId, ...restQuery }) => {
        var url = `whiteboards/${boardId}/shares?page=${page}&per_page=${perPage}`;
        if (restQuery) {
            for (let [query, value] of Object.entries(restQuery)) {
                url = url + `&${query}=${value}`;
            }
        }
        const response = await api.get(url);
        return response;
    },
    store: async ({ boardId, ...whiteboardShare }) => {
        const response = await api.post(
            `/whiteboards/${boardId}/shares`,
            { ...whiteboardShare }
        );
        return response.data;
    },
    get: async (boardId, id) => {
        const response = await api.get(`whiteboards/${boardId}/shares/${id}`);
        return response.data;
    },
    update: async (boardId, id, whiteboardShare) => {
        const response = await api.put(`whiteboards/${boardId}/shares/${id}`, whiteboardShare);
        return response.data;
    },
    updateMultiple: async (boardId, whiteboardShare) => {
        const response = await api.post(`whiteboards/${boardId}/shares/update`, whiteboardShare);
        return response.data;
    },
    delete: async (boardId, id) => {
        const response = await api.delete(`whiteboards/${boardId}/shares/${id}`);
        return response.data;
    },
    deleteAll: async (boardId) => {
        const response = await api.get(`whiteboards/${boardId}/shares/remove-all/${boardId}`);
        return response.data;
    },
    deleteMultiple: async (boardId, ids) => {
        const response = await api.post(`whiteboards/${boardId}/shares/delete`, { ids });
        return response.data;
    },
};

export default whiteboardShareResource;
